import { ContentTypography } from "../ServiceModal.styles";

export default function SharingLinkCopiedSuccessfully() {
    const modalContent = (
        <ContentTypography>
            Link erfolgreich in Zwischenablage kopiert!
        </ContentTypography>
    );
    return { modalContent, autoClosingModal: true };
}
